import * as React from 'react';
import { clsx } from 'clsx';

type Props = Readonly<{
	className?: string,
	innerClassName?: string,
	children?: React.ReactNode
}>;

function ColumnSide({
	children,
	className = '',
	innerClassName = ''
}: Props) {

	return (<>
		<div className={clsx(className, "px-3 sm:px-4 w-full lg:w-2/5 mb-6 lg:mb-16 xl:mb-24")}>
			<div className={clsx(innerClassName, "sticky top-8 bg-white text-black rounded-3xl overflow-hidden")}>
				{children}
			</div>
		</div>
	</>);
}

export default ColumnSide;
